import { Firebase } from '../../Firebase';
import { GTag } from '../../GTag';
import {
  AppDataSync,
  InstancesStore,
  AnalyticsModulesInitialization,
} from '../../Analytics/context';
import { firebaseConfigData } from '../../Firebase/Firebase.constants';

const analyticsModulesInit: AnalyticsModulesInitialization = {
  gtag: (appDataSync: AppDataSync) => getGtagInstances(appDataSync),
  firebase: (appDataSync: AppDataSync) => getFirebaseInstances(appDataSync),
};

export const getAnalyticsInstances = (appDataSync: AppDataSync) => {
  let analyticsInstances: InstancesStore = {};

  Object.keys(analyticsModulesInit).forEach(moduleName => {
    const appDataSyncModule = appDataSync[moduleName as keyof AppDataSync];

    if (appDataSyncModule) {
      const instancesByModule =
        analyticsModulesInit[
          moduleName as keyof AnalyticsModulesInitialization
        ]?.(appDataSync) || {};

      analyticsInstances = { ...analyticsInstances, ...instancesByModule };
    }
  });

  return analyticsInstances;
};

export const getGtagInstances = (appDataSync: AppDataSync) => {
  const gtag = appDataSync?.gtag;
  const gtagInstances: InstancesStore = {};

  if (gtag?.default) {
    const defaultInstance = new GTag();
    gtagInstances['DEFAULT_GTAG_INSTANCE'] = {
      mode: 'gtag',
      instance: defaultInstance,
    };
  }

  if (gtag?.configs) {
    gtag.configs.forEach(config => {
      if (!gtagInstances[config.name]) {
        const customInstance = new GTag(config.measurementId);

        gtagInstances[config.name] = {
          mode: 'gtag',
          instance: customInstance,
        };
      }
    });
  }

  return gtagInstances;
};

export const getFirebaseInstances = (appDataSync: AppDataSync) => {
  const firebaseConfigs = appDataSync?.firebase;
  const firebaseInstances: InstancesStore = {};
  const defaultInstanceName = 'DEFAULT_FIREBASE_ANALYTICS';

  if (firebaseConfigs?.default && !firebaseInstances[defaultInstanceName]) {
    const FirebaseInit = new Firebase();

    FirebaseInit.initializeFirebaseInstance(
      firebaseConfigData,
      defaultInstanceName
    );

    firebaseInstances[defaultInstanceName] = {
      mode: 'firebase',
      instance: FirebaseInit,
    };
  }

  if (firebaseConfigs?.configs) {
    firebaseConfigs.configs.forEach(instance => {
      if (!firebaseInstances[instance.name]) {
        const FirebaseInit = new Firebase();

        FirebaseInit.initializeFirebaseInstance(
          instance.firebaseConfig,
          instance.name
        );

        firebaseInstances[instance.name] = {
          mode: 'firebase',
          instance: FirebaseInit,
        };
      }
    });
  }

  return firebaseInstances;
};
